import { useTranslation } from 'react-i18next'
import { changeAppLanguage, SUPPORTED_UI_LANGUAGES, type UiLanguage } from '../i18n'

interface LanguageSwitcherProps {
  className?: string
  variant?: 'default' | 'auth'
}

export function LanguageSwitcher({ className = '', variant = 'default' }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation()
  const current = (i18n.language?.split('-')[0] || 'de') as UiLanguage

  const baseClass =
    variant === 'auth'
      ? 'inline-flex items-center rounded-xl border border-sky-200/80 bg-white/90 p-0.5 text-xs font-semibold shadow-sm'
      : 'inline-flex items-center rounded-lg border border-neutral-200 bg-white p-0.5 text-xs font-medium'

  return (
    <div
      className={`${baseClass} ${className}`}
      role="group"
      aria-label={t('common.languageSwitcher')}
    >
      {SUPPORTED_UI_LANGUAGES.map(code => {
        const active = current === code
        return (
          <button
            key={code}
            type="button"
            onClick={() => void changeAppLanguage(code)}
            aria-current={active ? 'true' : undefined}
            className={
              active
                ? variant === 'auth'
                  ? 'rounded-lg bg-sky-500 px-2.5 py-1 text-white'
                  : 'rounded-md bg-primary-500 px-2.5 py-1 text-white'
                : variant === 'auth'
                  ? 'rounded-lg px-2.5 py-1 text-slate-600 hover:text-sky-700'
                  : 'rounded-md px-2.5 py-1 text-neutral-600 hover:text-neutral-900'
            }
          >
            {code.toUpperCase()}
          </button>
        )
      })}
    </div>
  )
}
